export const formHelperMixin = {
  data() {
    return {
      buttonLoading: false,
      showError: false,
    };
  },
  methods: {
    displayError() {
      this.showError = true;
      this.buttonLoading = false;
    },
    displayErrorAndCloseDialog() {
      this.showError = true;
      this.closeDialog();
    },
  },
};
